export const ReclamationTypes = {
  ISendReclamationService: Symbol("ISendReclamationService"),
  ISendReclamationCloseService: Symbol("ISendReclamationCloseService"),
  IFilterAllReclamationService: Symbol("IFilterAllReclamationService"),
  IGetReclamationAdminService: Symbol("IGetReclamationAdminService"),
  IGetOneReclamationUserService: Symbol("IGetReclamationAdminService"),
};
